import { Routes } from '@angular/router';

export const routes: Routes = [
    {
        path: '',
        loadChildren: () => import('./panel/routes').then((r) => r.routes),
    },
    {
        path: 'auth',
        loadChildren: () => import('./auth/routes').then((r) => r.routes),
        title: 'Auth',
    },
];
